module.exports = __webpack_public_path__ + "static/media/gravel.b0e8fa44.png";